import z from "zod";
import { ZodStringNullable } from "../zod-types/zod-string-nullable";

export const calculationFormPositionItem = z.object({
	id: z.string().nullish().optional(),
	name: ZodStringNullable,
	ranking: z.number().min(0),
	quantity: z.number().nullish().optional(),
	length: z.number().nullish().optional(),
	width: z.number().nullish().optional(),
	height: z.number().nullish().optional(),
	meters: z.number().nullish().optional(),
	// When set, this overrides the dimension-based measurement (length×width, etc.) with a
	// directly-typed value, for when the user knows the result but not the exact dimensions.
	manualMeasurement: z.number().nullish().optional(),
});

export type CalculationFormPositionItem = z.infer<typeof calculationFormPositionItem>;
